<template>
    <div class="filter-column">
        <div class="result-filter facet-filter">
            <h5 class="filter-title">
                <div class="btn toggle-xs" data-toggle="collapse-next">
                    {{ $t("service_download.filter_sorting.category_headline") }}
                    <i class="icon icon-toggle-state"/>
                </div>
            </h5>
            <div class="scroll-content collapse" v-bar>
                <ul class="list-unstyled collapse">
                    <li
                        v-for="service in services"
                        :key="'button-' + service.id"
                    >
                        <facet-checkbox-item
                            :option="{name: $t('service.' + service.id), selected: isActiveService(service), id: service.id}"
                            @change="filterByService(service)"
                        />
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import FacetCheckboxItem from "@/components/facet/FacetCheckboxItem";

    export default {
        name: "CategoryFilter",
        components: {
            FacetCheckboxItem
        },
        computed: {
            ...mapState({
                services: state => state.services
            }),
        },
        methods: {
            isActiveService({ id }) {
                return this.$store.getters.isSearchCategory(id);
            },
            filterByService(service) {
                this.$store.commit('selectSearchCategory', service.id);

                const query = {
                    query: this.$store.state.search.query,
                    category: this.$store.state.search.category
                }

                this.$router.push({ query })
                this.$store.dispatch('getResults');
            },
        }
    }
</script>

<style scoped>

</style>